// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"703":"718eb3ed","975":"7d706b47"}[chunkId] + ".chunk.js";
};